import React, { useRef, useState } from "react";
import classes from "./OtpPage.module.css";
import { motion } from "framer-motion";
import { FaArrowLeft } from "react-icons/fa6";
import { useNavigate, useLocation } from "react-router-dom";
import { verifyOtp } from "../http/http";
import { setUser } from "../store/slices/userSlice";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

const OTP_LENGTH = 4;

const OtpPage = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(Array(OTP_LENGTH).fill(""));
  const inputsRef = useRef([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation();

  const handleChange = (value, index) => {
    const cleanValue = value.replace(/\D/g, "").slice(-1);

    const updatedOtp = [...otp];
    updatedOtp[index] = cleanValue;
    setOtp(updatedOtp);

    if (cleanValue && index < OTP_LENGTH - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        const updatedOtp = [...otp];
        updatedOtp[index] = "";
        setOtp(updatedOtp);
      } else if (index > 0) {
        inputsRef.current[index - 1]?.focus();
      }
    }

    if (e.key === "ArrowLeft" && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }

    if (e.key === "ArrowRight" && index < OTP_LENGTH - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, OTP_LENGTH);

    if (!pastedData) return;

    const updatedOtp = Array(OTP_LENGTH).fill("");
    pastedData.split("").forEach((digit, index) => {
      updatedOtp[index] = digit;
    });

    setOtp(updatedOtp);

    const nextIndex = Math.min(pastedData.length, OTP_LENGTH) - 1;
    if (nextIndex >= 0) {
      inputsRef.current[nextIndex]?.focus();
    }
  };

  const handleFormSubmission = async (e) => {
    e.preventDefault();

    const finalOtp = otp.join("");

    if (finalOtp.length !== OTP_LENGTH) {
      alert("Please enter the complete OTP.");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        msisdn: location.state?.mobile,
        otp: finalOtp,
      };

      const response = await verifyOtp(payload);

      if (response.data.success) {
        toast.success("OTP verified successfully.");
        dispatch(setUser(response.data));
        navigate("/home");
      } else {
        toast.error(response.data.msg || "Invalid OTP");
        navigate("/")
      }
    } catch (error) {
      console.error(error);
      console.log(error,"error---")
      toast.error(error?.response?.data?.msg || "Verification failed");
        navigate("/")
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className={classes.main}>
      <motion.section
        className={classes.container}
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.45, ease: "easeOut" }}
      >
        <div className={classes.bgGlowOne} />
        <div className={classes.bgGlowTwo} />

        <button
          type="button"
          className={classes.backBtn}
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft />
        </button>

        <div className={classes.topLogoWrap}>
          <img
            src="/images/moov-gaming-logo.png"
            alt="UV Gaming"
            className={classes.logoImg}
          />
        </div>

        <div className={classes.headingWrap}>
          <h1 className={classes.title}>
            {t("48")} <br />
            <span>{t("49")}</span>
          </h1>
          <p className={classes.subtitle}>{t("50")}</p>
        </div>

        <form className={classes.card} onSubmit={handleFormSubmission}>
          <div className={classes.infoBox}>
            <p className={classes.infoLabel}>{t("51")}</p>
            <p className={classes.infoValue}>+228 XXXXXXXXX</p>
          </div>

          <div className={classes.otpWrap} onPaste={handlePaste}>
            {otp.map((digit, index) => (
              <input
                key={index}
                ref={(el) => (inputsRef.current[index] = el)}
                type="text"
                inputMode="numeric"
                maxLength={1}
                value={digit}
                autoFocus={index === 0}
                onChange={(e) => handleChange(e.target.value, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                className={classes.otpInput}
              />
            ))}
          </div>

          <button type="submit" className={classes.confirmBtn} disabled={loading}>
            {loading ? "Verifying..." : t("52")}
          </button>

          <div className={classes.bottomRow}>
            <span className={classes.bottomText}>{t("53")}</span>
            <button type="button" className={classes.resendBtn}>
              {t("54")}
            </button>
          </div>
        </form>

        <div className={classes.footerText}>© UVCANN SOLUTIONS LLP</div>
      </motion.section>
    </main>
  );
};

export default OtpPage;